import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const RedirectRulesRoutes: RouteRecordRaw = {
  path: '/redirect-rules',
  name: 'RedirectRulesModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageRedirectRulesRoute',
      component: () => import('./views/ManageRedirectRulesView.vue'),
      meta: {
        title: 'قوانین ریدایرکت',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.redirectRules,
  },
}

export default (router: Router) => {
  router.addRoute(RedirectRulesRoutes)
}
